window.initImageBannerAnimation ?? (() => {
    window.initImageBannerAnimation = (section_id) => {

      const initPopElement = () => {

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.5,
            root: null
        });

        document.querySelectorAll(`section#shopify-section-${section_id} .pop`).forEach(el => observer.observe(el));
    }

    initPopElement();

    document.addEventListener('shopify:section:load', function () {
      initPopElement();
    });

    console.log('pop');
}
})();